import { useMemo } from 'react'
import { Flex } from '@mantine/core'

import { NotificationItem } from '@/modules/actionPlan/pages/components/NotificationItem/NotificationItem'
import { RecommendationItem } from '@/modules/actionPlan/pages/components/RecommendationItem/RecommendationItem'

import { Loader } from '@/components/Loader/Loader'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'

import {
  useGoalsServiceGoalsControllerGetRecommendations,
  useNotificationsServiceNotificationControllerGetAll,
} from '@/__generated__/queries'
import type {
  GoalRecommendationData,
  NotificationData,
} from '@/__generated__/requests'
import {
  action as NotificationAction,
  status3 as NotificationStatus,
} from '@/__generated__/requests'

export function Recommendations() {
  const { data, isFetching, isLoading } =
    useGoalsServiceGoalsControllerGetRecommendations()

  const {
    data: monthlyRemindersData,
    isFetching: monthlyRemindersIsFetching,
    isLoading: monthlyRemindersIsLoading,
  } = useNotificationsServiceNotificationControllerGetAll({
    action: NotificationAction.CLAIM_MONTHLY_REMINDER,
    status: NotificationStatus.UNREAD,
  })

  const recommendationList = useMemo<GoalRecommendationData[]>(
    () => data ?? [],
    [data],
  )

  const monthlyReminders = useMemo<NotificationData[]>(
    () => monthlyRemindersData ?? [],
    [monthlyRemindersData],
  )

  if (
    isFetching ||
    isLoading ||
    monthlyRemindersIsFetching ||
    monthlyRemindersIsLoading
  ) {
    return (
      <Flex mb={24}>
        <Loader isMinimized />
      </Flex>
    )
  }

  if (!recommendationList.length && !monthlyReminders.length) {
    return null
  }

  return (
    <ScrollArea mb={24}>
      <Flex gap={16} justify="center">
        {monthlyReminders.map(item => (
          <NotificationItem key={item.id} item={item} />
        ))}

        {recommendationList.map(item => (
          <RecommendationItem key={item.id} recommendation={item} />
        ))}
      </Flex>
    </ScrollArea>
  )
}
